<template>
  <IconLucideCirclePlus />
</template>
